import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  NoDataSkeleton,
  RowTableCell,
  TableBodySkeleton,
} from '../../../common';
import { formatCurrency } from '../utils/directDebitIcbcUtils';

const DirectDebitIcbcDataTable = ({ records, excluded, isLoading }) => (
  <>
    <GeneralTableBox>
      <Table aria-label="direct debit ICBC records table">
        <TableHead>
          <TableRow>
            <HeadTableCell>Contrato</HeadTableCell>
            <HeadTableCell>Cupón</HeadTableCell>
            <HeadTableCell>Venc.</HeadTableCell>
            <HeadTableCell>Plan</HeadTableCell>
            <HeadTableCell>Grupo</HeadTableCell>
            <HeadTableCell>Suscriptores</HeadTableCell>
            <HeadTableCell>CBU1</HeadTableCell>
            <HeadTableCell>CBU2</HeadTableCell>
            <HeadTableCell>ID cliente</HeadTableCell>
            <HeadTableCell align="right">Monto</HeadTableCell>
            <HeadTableCell>Vencimiento</HeadTableCell>
            <HeadTableCell>Referencia</HeadTableCell>
            <HeadTableCell>Largo</HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TableBodySkeleton rows={6} columns={13} />
          ) : records.length > 0 ? (
            records.map((record) => (
              <TableRow key={`${record.contract_uuid}-${record.coupon_uuid}-${record.due_number}`}>
                <RowTableCell>{record.contract_number}</RowTableCell>
                <RowTableCell>{record.coupon_code_number}</RowTableCell>
                <RowTableCell>{record.due_label || '-'}</RowTableCell>
                <RowTableCell>{record.plan || '-'}</RowTableCell>
                <RowTableCell>{record.group || '-'}</RowTableCell>
                <RowTableCell>{record.subscribers || '-'}</RowTableCell>
                <RowTableCell>{record.cbu1}</RowTableCell>
                <RowTableCell>{record.cbu2}</RowTableCell>
                <RowTableCell>{record.id_cliente}</RowTableCell>
                <RowTableCell align="right">{formatCurrency(record.amount)}</RowTableCell>
                <RowTableCell>{record.due_date}</RowTableCell>
                <RowTableCell>{record.reference}</RowTableCell>
                <RowTableCell>{record.line_length}</RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton colSpan={13} message="No se encontraron débitos exportables" />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>

    {excluded.length > 0 && (
      <GeneralTableBox sx={{ mt: 2 }}>
        <Table aria-label="direct debit ICBC exclusions table">
          <TableHead>
            <TableRow>
              <HeadTableCell>Contrato</HeadTableCell>
              <HeadTableCell>Cupón</HeadTableCell>
              <HeadTableCell>Plan</HeadTableCell>
              <HeadTableCell>Grupo</HeadTableCell>
              <HeadTableCell>Suscriptores</HeadTableCell>
              <HeadTableCell>Motivo</HeadTableCell>
              <HeadTableCell>Detalle</HeadTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {excluded.map((item, index) => (
              <TableRow key={`${item.contract_uuid}-${item.coupon_uuid || index}`}>
                <RowTableCell>{item.contract_number}</RowTableCell>
                <RowTableCell>{item.coupon_code_number || '-'}</RowTableCell>
                <RowTableCell>{item.plan || '-'}</RowTableCell>
                <RowTableCell>{item.group || '-'}</RowTableCell>
                <RowTableCell>{item.subscribers || '-'}</RowTableCell>
                <RowTableCell>{item.reason}</RowTableCell>
                <RowTableCell>{item.detail}</RowTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </GeneralTableBox>
    )}
  </>
);

export default DirectDebitIcbcDataTable;
